const serializeAnswers = (answers) => {
  let results = [];

  if (answers) {
    for (const [key, value] of Object.entries(answers)) {
      results.push({
        question: key,
        answer: value,
      });
    }
  }

  return { results };
};

export {
  serializeAnswers,
};
